export const getBaseURL = () => {
  const hostname = window.location.hostname
  const http = window.location.protocol
  const baseURL =
    hostname === 'localhost'
      ? window.location.origin + process.env.VUE_APP_BASE_API
      : http + '//api' + hostname.substring(hostname.indexOf('.')) + '/api'
  return baseURL
}

export const getFileUploadURL = () => {
  const hostname = window.location.hostname
  const http = window.location.protocol
  const baseURL =
    hostname === 'localhost'
      ? process.env.VUE_APP_BASE_API
      : http + '//api' + hostname.substring(hostname.indexOf('.')) + `/api`
  return baseURL
}

export const statusList: any[] = [
  { type: 'danger', text: 'Disable' },
  { type: 'success', text: 'Active' }
]

export const notifiedStatusList: any[] = [
  { type: 'danger', text: 'Not Notified' },
  { type: 'success', text: 'Notified' },
  { type: 'warning', text: 'Notice failure' }
  // { type: 'info', text: '□' },
  // { type: 'success', text: '☑' },
  // { type: 'danger', text: '☒' }
]

export const orderStatusList: any[] = [
  { type: 'info', text: 'non-payment' },
  { type: 'success', text: 'payment success' },
  { type: 'warning', text: 'await audit' },
  { type: 'primary', text: 'Dispensing' },
  { type: 'danger', text: 'order failed' }
]

export const auditStatusList: any[] = [
  { type: 'info', text: 'Pending' },
  { type: 'success', text: 'Approve' },
  { type: 'danger', text: 'Reject' }
]

export const auditAddStatusList: any[] = [
  { type: 'info', text: 'Pending' },
  { type: 'success', text: 'Approve' },
  { type: 'danger', text: 'Reject' },
  { type: 'warning', text: 'Bound' }
]

export const onlinestatusList: any[] = [
  { type: 'danger', text: 'Offline' },
  { type: 'success', text: 'Online' }
]

export const upStreamStatusList: any = {
  0: 'primary',
  1: 'success',
  2: 'info',
  3: 'warning',
  4: 'info',
  5: 'danger',
  6: 'warning',
  7: 'danger'
}
export const notifiedStatus: any = {
  0: 'danger',
  1: 'success',
  2: 'warning'
}

// 任务中心-处理时间单位
export const timeTypeList: any[] = ['minutes', 'hours']

// 结算时间下拉项1
export const timeList1: any[] = [
  { value: '00', label: '00' },
  { value: '01', label: '01' },
  { value: '02', label: '02' },
  { value: '03', label: '03' },
  { value: '04', label: '04' },
  { value: '05', label: '05' },
  { value: '06', label: '06' },
  { value: '07', label: '07' },
  { value: '08', label: '08' },
  { value: '09', label: '09' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' }
]
// 结算时间下拉项2
export const timeList2: any[] = [
  { value: '00', label: '00' },
  { value: '01', label: '01' },
  { value: '02', label: '02' },
  { value: '03', label: '03' },
  { value: '04', label: '04' },
  { value: '05', label: '05' },
  { value: '06', label: '06' },
  { value: '07', label: '07' },
  { value: '08', label: '08' },
  { value: '09', label: '09' },
  { value: '10', label: '10' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' },
  { value: '24', label: '24' },
  { value: '25', label: '25' },
  { value: '26', label: '26' },
  { value: '27', label: '27' },
  { value: '28', label: '28' },
  { value: '29', label: '29' },
  { value: '30', label: '30' },
  { value: '31', label: '31' },
  { value: '32', label: '32' },
  { value: '33', label: '33' },
  { value: '34', label: '34' },
  { value: '35', label: '35' },
  { value: '36', label: '36' },
  { value: '37', label: '37' },
  { value: '38', label: '38' },
  { value: '39', label: '39' },
  { value: '40', label: '40' },
  { value: '41', label: '41' },
  { value: '42', label: '42' },
  { value: '43', label: '43' },
  { value: '44', label: '44' },
  { value: '45', label: '45' },
  { value: '46', label: '46' },
  { value: '47', label: '47' },
  { value: '48', label: '48' },
  { value: '49', label: '49' },
  { value: '50', label: '50' },
  { value: '51', label: '51' },
  { value: '52', label: '52' },
  { value: '53', label: '53' },
  { value: '54', label: '54' },
  { value: '55', label: '55' },
  { value: '56', label: '56' },
  { value: '57', label: '57' },
  { value: '58', label: '58' },
  { value: '59', label: '59' }
]

// 全球支付 收款货币
export const paymentCurrency: any[] = [
  'ARS',
  'AUD',
  'BDT',
  'BOB',
  'BRL',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CZK',
  'DKK',
  'EGP',
  'EUR',
  'GBP',
  'HKD',
  'IDR',
  'INR',
  'JPY',
  'KES',
  'KHR',
  'KRW',
  'LKR',
  'MAD',
  'MXN',
  'MYR',
  'NOK',
  'PEN',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'SEK',
  'SGD',
  'THB',
  'TRY',
  'USD',
  'UYU',
  'VND'
]

// 全球支付 账户所在地区
export const paymentCountry: any[] = [
  {
    name: '中国大陆',
    en_name: 'CHINA',
    country_code: 'CN',
    area_phone_code: '86',
    currency: 'CNY',
    currency_name: '人民币元',
    id: 183
  },
  {
    name: '香港',
    en_name: 'HONG KONG',
    country_code: 'HK',
    area_phone_code: '852',
    currency: 'HKD',
    currency_name: '',
    id: 72
  },
  {
    name: '安道尔',
    en_name: 'ANDORRA',
    country_code: 'AD',
    area_phone_code: '376',
    currency: 'EUR',
    currency_name: '欧元',
    id: 4
  },
  {
    name: '阿根廷',
    en_name: 'ARGENTINA',
    country_code: 'AR',
    area_phone_code: '54',
    currency: 'ARS',
    currency_name: '阿根廷比索',
    id: 7
  },
  {
    name: '阿鲁巴',
    en_name: 'ARUBA',
    country_code: 'AW',
    area_phone_code: '297',
    currency: 'AWG',
    currency_name: '阿鲁巴弗洛林',
    id: 9
  },
  {
    name: '澳大利亚',
    en_name: 'AUSTRALIA',
    country_code: 'AU',
    area_phone_code: '61',
    currency: 'AUD',
    currency_name: '澳元',
    id: 10
  },
  {
    name: '奥地利',
    en_name: 'AUSTRIA',
    country_code: 'AT',
    area_phone_code: '43',
    currency: 'EUR',
    currency_name: '欧元',
    id: 11
  },
  {
    name: '阿塞拜疆',
    en_name: 'AZERBAIJAN',
    country_code: 'AZ',
    area_phone_code: '994',
    currency: 'AZN',
    currency_name: '阿塞拜疆马纳特',
    id: 12
  },
  {
    name: '巴林',
    en_name: 'BAHRAIN',
    country_code: 'BH',
    area_phone_code: '973',
    currency: 'BHD',
    currency_name: '巴林第纳尔',
    id: 13
  },
  {
    name: '孟加拉国',
    en_name: 'BANGLADESH',
    country_code: 'BD',
    area_phone_code: '880',
    currency: 'BDT',
    currency_name: '塔卡',
    id: 14
  },
  {
    name: '比利时',
    en_name: 'BELGIUM',
    country_code: 'BE',
    area_phone_code: '32',
    currency: 'EUR',
    currency_name: '欧元',
    id: 15
  },
  {
    name: '伯利兹',
    en_name: 'BELIZE',
    country_code: 'BZ',
    area_phone_code: '501',
    currency: 'BZD',
    currency_name: '伯利兹元',
    id: 16
  },
  {
    name: '贝宁',
    en_name: 'BENIN',
    country_code: 'BJ',
    area_phone_code: '229',
    currency: 'XOF',
    currency_name: '多哥非洲共同体法郎',
    id: 17
  },
  {
    name: '百慕大群岛',
    en_name: 'BERMUDA',
    country_code: 'BM',
    area_phone_code: '1441',
    currency: 'BMD',
    currency_name: '百慕大元',
    id: 18
  },
  {
    name: '不丹',
    en_name: 'BHUTAN',
    country_code: 'BT',
    area_phone_code: '975',
    currency: 'INR',
    currency_name: '印度卢比',
    id: 19
  },
  {
    name: '玻利维亚多民族国',
    en_name: 'BOLIVIA, PLURINATIONAL STATE OF',
    country_code: 'BO',
    area_phone_code: '591',
    currency: 'BOV',
    currency_name: '玻利维亚资金',
    id: 20
  },
  {
    name: '波斯尼亚和黑塞哥维那',
    en_name: 'BOSNIA AND HERZEGOVINA',
    country_code: 'BA',
    area_phone_code: '387',
    currency: 'BAM',
    currency_name: '可兑换马克',
    id: 22
  },
  {
    name: '巴西',
    en_name: 'BRAZIL',
    country_code: 'BR',
    area_phone_code: '55',
    currency: 'BRL',
    currency_name: '巴西雷亚尔',
    id: 23
  },
  {
    name: '文莱达鲁萨兰国',
    en_name: 'BRUNEI DARUSSALAM',
    country_code: 'BN',
    area_phone_code: '673',
    currency: 'BND',
    currency_name: '文莱元',
    id: 24
  },
  {
    name: '保加利亚',
    en_name: 'BULGARIA',
    country_code: 'BG',
    area_phone_code: '359',
    currency: 'BGN',
    currency_name: '保加利亚列瓦',
    id: 25
  },
  {
    name: '喀麦隆',
    en_name: 'CAMEROON',
    country_code: 'CM',
    area_phone_code: '237',
    currency: 'XAF',
    currency_name: '多哥非洲共同体法郎',
    id: 28
  },
  {
    name: '佛得角',
    en_name: 'CAPE VERDE',
    country_code: 'CV',
    area_phone_code: '238',
    currency: 'CVE',
    currency_name: '佛得角埃斯库多',
    id: 27
  },
  {
    name: '开曼群岛',
    en_name: 'CAYMAN ISLANDS',
    country_code: 'KY',
    area_phone_code: '1345',
    currency: 'KYD',
    currency_name: '开曼群岛元',
    id: 29
  },
  {
    name: '乍得',
    en_name: 'CHAD',
    country_code: 'TD',
    area_phone_code: '235',
    currency: 'XAF',
    currency_name: '多哥非洲共同体法郎',
    id: 30
  },
  {
    name: '智利',
    en_name: 'CHILE',
    country_code: 'CL',
    area_phone_code: '56',
    currency: 'CLF',
    currency_name: '智利资金',
    id: 31
  },
  {
    name: '科摩罗',
    en_name: 'COMOROS',
    country_code: 'KM',
    area_phone_code: '269',
    currency: 'KMF',
    currency_name: '科摩罗法郎',
    id: 33
  },
  {
    name: '库克群岛',
    en_name: 'COOK ISLANDS',
    country_code: 'CK',
    area_phone_code: '682',
    currency: 'NZD',
    currency_name: '新西兰元',
    id: 34
  },
  {
    name: '哥斯达黎加',
    en_name: 'COSTA RICA',
    country_code: 'CR',
    area_phone_code: '506',
    currency: 'CRC',
    currency_name: '哥斯达尼家科朗',
    id: 35
  },
  {
    name: '克罗地亚',
    en_name: 'CROATIA',
    country_code: 'HR',
    area_phone_code: '385',
    currency: 'HRK',
    currency_name: '库纳',
    id: 36
  },
  {
    name: '塞浦路斯',
    en_name: 'CYPRUS',
    country_code: 'CY',
    area_phone_code: '357',
    currency: 'EUR',
    currency_name: '欧元',
    id: 38
  },
  {
    name: '捷克',
    en_name: 'Czech Republic',
    country_code: 'CZ',
    area_phone_code: '420',
    currency: 'CZK',
    currency_name: '捷克克朗',
    id: 39
  },
  {
    name: '丹麦',
    en_name: 'DENMARK',
    country_code: 'DK',
    area_phone_code: '45',
    currency: 'DKK',
    currency_name: '丹麦克朗',
    id: 40
  },
  {
    name: '吉布提',
    en_name: 'DJIBOUTI',
    country_code: 'DJ',
    area_phone_code: '253',
    currency: 'DJF',
    currency_name: '吉布提法郎',
    id: 41
  },
  {
    name: '多米尼加',
    en_name: 'DOMINICA',
    country_code: 'DM',
    area_phone_code: '1767',
    currency: 'XCD',
    currency_name: '东加勒比元',
    id: 42
  },
  {
    name: '厄瓜多尔',
    en_name: 'ECUADOR',
    country_code: 'EC',
    area_phone_code: '593',
    currency: 'USD',
    currency_name: '美元',
    id: 44
  },
  {
    name: '埃及',
    en_name: 'EGYPT',
    country_code: 'EG',
    area_phone_code: '20',
    currency: 'EGP',
    currency_name: '埃及镑',
    id: 45
  },
  {
    name: '萨尔瓦多',
    en_name: 'EL SALVADOR',
    country_code: 'SV',
    area_phone_code: '503',
    currency: 'USD',
    currency_name: '美元',
    id: 46
  },
  {
    name: '赤道几内亚',
    en_name: 'EQUATORIAL GUINEA',
    country_code: 'GQ',
    area_phone_code: '240',
    currency: 'XAF',
    currency_name: '多哥非洲共同体法郎',
    id: 47
  },
  {
    name: '爱沙尼亚',
    en_name: 'ESTONIA',
    country_code: 'EE',
    area_phone_code: '372',
    currency: 'EUR',
    currency_name: '欧元',
    id: 48
  },
  {
    name: '福克兰群岛（马尔维纳斯）',
    en_name: 'FALKLAND ISLANDS (MALVINAS)',
    country_code: 'FK',
    area_phone_code: '500',
    currency: 'FKP',
    currency_name: '福克兰群岛镑',
    id: 50
  },
  {
    name: '法罗群岛',
    en_name: 'FAROE ISLANDS',
    country_code: 'FO',
    area_phone_code: '298',
    currency: 'DKK',
    currency_name: '丹麦克朗',
    id: 51
  },
  {
    name: '斐济',
    en_name: 'FIJI',
    country_code: 'FJ',
    area_phone_code: '679',
    currency: 'FJD',
    currency_name: '斐济元',
    id: 52
  },
  {
    name: '芬兰',
    en_name: 'FINLAND',
    country_code: 'FI',
    area_phone_code: '358',
    currency: 'EUR',
    currency_name: '欧元',
    id: 53
  },
  {
    name: '法国',
    en_name: 'FRANCE',
    country_code: 'FR',
    area_phone_code: '33',
    currency: 'EUR',
    currency_name: '欧元',
    id: 54
  },
  {
    name: '法属波利尼西亚',
    en_name: 'FRENCH POLYNESIA',
    country_code: 'PF',
    area_phone_code: '689',
    currency: 'XOF',
    currency_name: '多哥非洲共同体法郎',
    id: 56
  },
  {
    name: '加蓬',
    en_name: 'GABON',
    country_code: 'GA',
    area_phone_code: '241',
    currency: 'XAF',
    currency_name: '多哥非洲共同体法郎',
    id: 57
  },
  {
    name: '冈比亚',
    en_name: 'GAMBIA',
    country_code: 'GM',
    area_phone_code: '220',
    currency: 'GMD',
    currency_name: '达拉西',
    id: 58
  },
  {
    name: '格鲁吉亚',
    en_name: 'GEORGIA',
    country_code: 'GE',
    area_phone_code: '995',
    currency: 'GEL',
    currency_name: '拉里',
    id: 59
  },
  {
    name: '德国',
    en_name: 'GERMANY',
    country_code: 'DE',
    area_phone_code: '49',
    currency: 'EUR',
    currency_name: '欧元',
    id: 60
  },
  {
    name: '直布罗陀',
    en_name: 'GIBRALTAR',
    country_code: 'GI',
    area_phone_code: '350',
    currency: 'GIP',
    currency_name: '直布罗陀镑',
    id: 61
  },
  {
    name: '希腊',
    en_name: 'GREECE',
    country_code: 'GR',
    area_phone_code: '30',
    currency: 'EUR',
    currency_name: '欧元',
    id: 62
  },
  {
    name: '格林纳达',
    en_name: 'GRENADA',
    country_code: 'GD',
    area_phone_code: '1473',
    currency: 'XCD',
    currency_name: '东加勒比元',
    id: 64
  },
  {
    name: '瓜德罗普',
    en_name: 'GUADELOUPE',
    country_code: 'GP',
    area_phone_code: '590',
    currency: 'EUR',
    currency_name: '欧元',
    id: 65
  },
  {
    name: '关岛',
    en_name: 'GUAM',
    country_code: 'GU',
    area_phone_code: '1671',
    currency: 'USD',
    currency_name: '美元',
    id: 66
  },
  {
    name: '塞尔维亚',
    en_name: 'SERBIA',
    country_code: 'RS',
    area_phone_code: '381',
    currency: 'RSD',
    currency_name: '塞尔维亚第纳尔',
    id: 1
  },
  {
    name: '埃斯瓦蒂尼',
    en_name: 'ESWATINI',
    country_code: 'SZ',
    area_phone_code: '268',
    currency: 'SZL',
    currency_name: '里兰基尼',
    id: 49
  },
  {
    name: '安提瓜和巴布达',
    en_name: 'ANTIGUA AND BARBUDA',
    country_code: 'AG',
    area_phone_code: '1268',
    currency: 'XCD',
    currency_name: '东加勒比元',
    id: 6
  },
  {
    name: '根西岛',
    en_name: 'GUERNSEY',
    country_code: 'GG',
    area_phone_code: '44',
    currency: 'GBP',
    currency_name: '英镑',
    id: 68
  },
  {
    name: '圭亚那',
    en_name: 'GUYANA',
    country_code: 'GY',
    area_phone_code: '592',
    currency: 'GYD',
    currency_name: '圭亚那元',
    id: 69
  },
  {
    name: '海地',
    en_name: 'HAITI',
    country_code: 'HT',
    area_phone_code: '509',
    currency: 'USD',
    currency_name: '美元',
    id: 70
  },
  {
    name: '匈牙利',
    en_name: 'HUNGARY',
    country_code: 'HU',
    area_phone_code: '36',
    currency: 'HUF',
    currency_name: '福林',
    id: 73
  },
  {
    name: '印度',
    en_name: 'INDIA',
    country_code: 'IN',
    area_phone_code: '91',
    currency: 'INR',
    currency_name: '印度卢比',
    id: 74
  },
  {
    name: '马恩岛',
    en_name: 'ISLE OF MAN',
    country_code: 'IM',
    area_phone_code: '44',
    currency: 'GBP',
    currency_name: '英镑',
    id: 77
  },
  {
    name: '以色列',
    en_name: 'ISRAEL',
    country_code: 'IL',
    area_phone_code: '972',
    currency: 'ILS',
    currency_name: '新谢克尔',
    id: 78
  },
  {
    name: '意大利',
    en_name: 'ITALY',
    country_code: 'IT',
    area_phone_code: '39',
    currency: 'EUR',
    currency_name: '欧元',
    id: 79
  },
  {
    name: '日本',
    en_name: 'JAPAN',
    country_code: 'JP',
    area_phone_code: '81',
    currency: 'JPY',
    currency_name: '日元',
    id: 80
  },
  {
    name: '泽西',
    en_name: 'JERSEY',
    country_code: 'JE',
    area_phone_code: '44',
    currency: 'GBP',
    currency_name: '英镑',
    id: 81
  },
  {
    name: '哈萨克斯坦',
    en_name: 'KAZAKHSTAN',
    country_code: 'KZ',
    area_phone_code: '7',
    currency: 'KZT',
    currency_name: '腾格',
    id: 82
  },
  {
    name: '肯尼亚',
    en_name: 'KENYA',
    country_code: 'KE',
    area_phone_code: '254',
    currency: 'KES',
    currency_name: '肯尼亚先令',
    id: 83
  },
  {
    name: '基里巴斯',
    en_name: 'KIRIBATI',
    country_code: 'KI',
    area_phone_code: '686',
    currency: 'AUD',
    currency_name: '澳元',
    id: 84
  },
  {
    name: '科索沃共和国',
    en_name: 'KOSOVO, REPUBLIC OF',
    country_code: 'XK',
    area_phone_code: '383',
    currency: 'EUR',
    currency_name: '欧元',
    id: 86
  },
  {
    name: '科威特',
    en_name: 'KUWAIT',
    country_code: 'KW',
    area_phone_code: '965',
    currency: 'KWD',
    currency_name: '科威特第纳尔',
    id: 87
  },
  {
    name: '吉尔吉斯斯坦',
    en_name: 'KYRGYZSTAN',
    country_code: 'KG',
    area_phone_code: '996',
    currency: 'KGS',
    currency_name: '索姆',
    id: 88
  },
  {
    name: '莱索托',
    en_name: 'LESOTHO',
    country_code: 'LS',
    area_phone_code: '266',
    currency: 'ZAR',
    currency_name: '兰特',
    id: 91
  },
  {
    name: '列支敦士登',
    en_name: 'LIECHTENSTEIN',
    country_code: 'LI',
    area_phone_code: '423',
    currency: 'CHF',
    currency_name: '瑞士法郎',
    id: 92
  },
  {
    name: '立陶宛',
    en_name: 'LITHUANIA',
    country_code: 'LT',
    area_phone_code: '370',
    currency: 'EUR',
    currency_name: '欧元',
    id: 93
  },
  {
    name: '卢森堡',
    en_name: 'LUXEMBOURG',
    country_code: 'LU',
    area_phone_code: '352',
    currency: 'EUR',
    currency_name: '欧元',
    id: 94
  },
  {
    name: '澳门',
    en_name: 'MACAO',
    country_code: 'MO',
    area_phone_code: '853',
    currency: 'MOP',
    currency_name: '澳元',
    id: 95
  },
  {
    name: '北马其顿',
    en_name: 'NORTH MACEDONIA',
    country_code: 'MK',
    area_phone_code: '389',
    currency: 'MKD',
    currency_name: '第纳尔',
    id: 121
  },
  {
    name: '马达加斯加',
    en_name: 'MADAGASCAR',
    country_code: 'MG',
    area_phone_code: '261',
    currency: 'MGA',
    currency_name: '阿里亚里',
    id: 96
  },
  {
    name: '马拉维',
    en_name: 'MALAWI',
    country_code: 'MW',
    area_phone_code: '265',
    currency: 'MWK',
    currency_name: '克瓦查',
    id: 97
  },
  {
    name: '马来西亚',
    en_name: 'MALAYSIA',
    country_code: 'MY',
    area_phone_code: '60',
    currency: 'MYR',
    currency_name: '马来西亚林吉特',
    id: 98
  },
  {
    name: '马尔代夫',
    en_name: 'MALDIVES',
    country_code: 'MV',
    area_phone_code: '960',
    currency: 'MVR',
    currency_name: '拉菲亚',
    id: 99
  },
  {
    name: '马耳他',
    en_name: 'MALTA',
    country_code: 'MT',
    area_phone_code: '356',
    currency: 'EUR',
    currency_name: '欧元',
    id: 100
  },
  {
    name: '马绍尔群岛',
    en_name: 'MARSHALL ISLANDS',
    country_code: 'MH',
    area_phone_code: '692',
    currency: 'USD',
    currency_name: '美元',
    id: 101
  },
  {
    name: '马提尼克',
    en_name: 'MARTINIQUE',
    country_code: 'MQ',
    area_phone_code: '596',
    currency: 'EUR',
    currency_name: '欧元',
    id: 102
  },
  {
    name: '毛里塔尼亚',
    en_name: 'MAURITANIA',
    country_code: 'MR',
    area_phone_code: '222',
    currency: 'MRU',
    currency_name: '乌吉亚',
    id: 103
  },
  {
    name: '马约特',
    en_name: 'MAYOTTE',
    country_code: 'YT',
    area_phone_code: '262',
    currency: 'EUR',
    currency_name: '欧元',
    id: 104
  },
  {
    name: '摩尔多瓦共和国',
    en_name: 'MOLDOVA',
    country_code: 'MD',
    area_phone_code: '373',
    currency: 'MDL',
    currency_name: '摩尔多瓦尼乌',
    id: 107
  },
  {
    name: '摩纳哥',
    en_name: 'MONACO',
    country_code: 'MC',
    area_phone_code: '377',
    currency: 'EUR',
    currency_name: '欧元',
    id: 108
  },
  {
    name: '黑山',
    en_name: 'MONTENEGRO',
    country_code: 'ME',
    area_phone_code: '382',
    currency: 'EUR',
    currency_name: '欧元',
    id: 109
  },
  {
    name: '蒙特塞拉特',
    en_name: 'MONTSERRAT',
    country_code: 'MS',
    area_phone_code: '1664',
    currency: 'XCD',
    currency_name: '东加勒比元',
    id: 110
  },
  {
    name: '摩洛哥',
    en_name: 'MOROCCO',
    country_code: 'MA',
    area_phone_code: '212',
    currency: 'MAD',
    currency_name: '摩洛哥迪拉姆',
    id: 111
  },
  {
    name: '莫桑比克',
    en_name: 'MOZAMBIQUE',
    country_code: 'MZ',
    area_phone_code: '258',
    currency: 'MZN',
    currency_name: '莫桑比克梅蒂卡尔',
    id: 112
  },
  {
    name: '瑙鲁',
    en_name: 'NAURU',
    country_code: 'NR',
    area_phone_code: '674',
    currency: 'AUD',
    currency_name: '澳元',
    id: 114
  },
  {
    name: '尼泊尔',
    en_name: 'NEPAL',
    country_code: 'NP',
    area_phone_code: '977',
    currency: 'NPR',
    currency_name: '尼泊尔卢比',
    id: 115
  },
  {
    name: '荷兰',
    en_name: 'NETHERLANDS',
    country_code: 'NL',
    area_phone_code: '31',
    currency: 'EUR',
    currency_name: '欧元',
    id: 116
  },
  {
    name: '新喀里多尼亚',
    en_name: 'NEW CALEDONIA',
    country_code: 'NC',
    area_phone_code: '687',
    currency: 'XOF',
    currency_name: '多哥非洲共同体法郎',
    id: 117
  },
  {
    name: '尼日尔',
    en_name: 'NIGER',
    country_code: 'NE',
    area_phone_code: '227',
    currency: 'XOF',
    currency_name: '多哥非洲共同体法郎',
    id: 119
  },
  {
    name: '尼日利亚',
    en_name: 'NIGERIA',
    country_code: 'NG',
    area_phone_code: '234',
    currency: 'NGN',
    currency_name: '奈拉',
    id: 120
  },
  {
    name: '北马里亚纳群岛',
    en_name: 'NORTHERN MARIANA ISLANDS',
    country_code: 'MP',
    area_phone_code: '1670',
    currency: 'USD',
    currency_name: '美元',
    id: 122
  },
  {
    name: '挪威',
    en_name: 'NORWAY',
    country_code: 'NO',
    area_phone_code: '47',
    currency: 'NOK',
    currency_name: '挪威克朗',
    id: 123
  },
  {
    name: '阿曼',
    en_name: 'OMAN',
    country_code: 'OM',
    area_phone_code: '968',
    currency: 'OMR',
    currency_name: '阿曼里亚尔',
    id: 124
  },
  {
    name: '帕劳',
    en_name: 'PALAU',
    country_code: 'PW',
    area_phone_code: '680',
    currency: 'USD',
    currency_name: '美元',
    id: 125
  },
  {
    name: '巴布亚新几内亚',
    en_name: 'PAPUA NEW GUINEA',
    country_code: 'PG',
    area_phone_code: '675',
    currency: 'PGK',
    currency_name: '基那',
    id: 126
  },
  {
    name: '巴拉圭',
    en_name: 'PARAGUAY',
    country_code: 'PY',
    area_phone_code: '595',
    currency: 'PYG',
    currency_name: '瓜拉尼',
    id: 127
  },
  {
    name: '秘鲁',
    en_name: 'PERU',
    country_code: 'PE',
    area_phone_code: '51',
    currency: 'PEN',
    currency_name: '新索尔',
    id: 128
  },
  {
    name: '菲律宾',
    en_name: 'PHILIPPINES',
    country_code: 'PH',
    area_phone_code: '63',
    currency: 'PHP',
    currency_name: '菲律宾比索',
    id: 129
  },
  {
    name: '波兰',
    en_name: 'POLAND',
    country_code: 'PL',
    area_phone_code: '48',
    currency: 'PLN',
    currency_name: '兹罗提',
    id: 130
  },
  {
    name: '葡萄牙',
    en_name: 'PORTUGAL',
    country_code: 'PT',
    area_phone_code: '351',
    currency: 'EUR',
    currency_name: '欧元',
    id: 131
  },
  {
    name: '波多黎各',
    en_name: 'PUERTO RICO',
    country_code: 'PR',
    area_phone_code: '1',
    currency: 'USD',
    currency_name: '美元',
    id: 132
  },
  {
    name: '卡塔尔',
    en_name: 'QATAR',
    country_code: 'QA',
    area_phone_code: '974',
    currency: 'QAR',
    currency_name: '卡塔尔里亚尔',
    id: 133
  },
  {
    name: '韩国',
    en_name: 'KOREA, REPUBLIC OF',
    country_code: 'KR',
    area_phone_code: '82',
    currency: 'KRW',
    currency_name: '韩元',
    id: 85
  },
  {
    name: '梵蒂冈',
    en_name: 'VATICAN CITY',
    country_code: 'VA',
    area_phone_code: '39',
    currency: 'EUR',
    currency_name: '欧元',
    id: 71
  },
  {
    name: '亚美尼亚',
    en_name: 'ARMENIA',
    country_code: 'AM',
    area_phone_code: '374',
    currency: 'AMD',
    currency_name: '亚美尼亚德拉姆',
    id: 8
  },
  {
    name: '柬埔寨',
    en_name: 'CAMBODIA',
    country_code: 'KH',
    area_phone_code: '855',
    currency: 'KHR',
    currency_name: '瑞尔',
    id: 186
  },
  {
    name: '哥伦比亚',
    en_name: 'COLOMBIA',
    country_code: 'CO',
    area_phone_code: '57',
    currency: 'COU',
    currency_name: '哥伦比亚Unidad de Valor Real',
    id: 32
  },
  {
    name: '库拉索',
    en_name: 'CURACAO',
    country_code: 'CW',
    area_phone_code: '599',
    currency: 'ANG',
    currency_name: '荷属安的列斯盾',
    id: 37
  },
  {
    name: '埃塞俄比亚',
    en_name: 'ETHIOPIA',
    country_code: 'ET',
    area_phone_code: '251',
    currency: 'ETB',
    currency_name: '埃塞俄比亚比尔',
    id: 185
  },
  {
    name: '格陵兰',
    en_name: 'GREENLAND',
    country_code: 'GL',
    area_phone_code: '299',
    currency: 'DKK',
    currency_name: '丹麦克朗',
    id: 63
  },
  {
    name: '冰岛',
    en_name: 'Iceland',
    country_code: 'IS',
    area_phone_code: '354',
    currency: 'ISK',
    currency_name: '冰岛克朗',
    id: 182
  },
  {
    name: '印度尼西亚',
    en_name: 'INDONESIA',
    country_code: 'ID',
    area_phone_code: '62',
    currency: 'IDR',
    currency_name: '卢比',
    id: 75
  },
  {
    name: '约旦',
    en_name: 'JORDAN',
    country_code: 'JO',
    area_phone_code: '962',
    currency: 'JOD',
    currency_name: '约旦第纳尔',
    id: 189
  },
  {
    name: '老挝人民民主共和国',
    en_name: "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
    country_code: 'LA',
    area_phone_code: '856',
    currency: 'LAK',
    currency_name: '基普',
    id: 89
  },
  {
    name: '新西兰',
    en_name: 'NEW ZEALAND',
    country_code: 'NZ',
    area_phone_code: '64',
    currency: 'NZD',
    currency_name: '新西兰元',
    id: 118
  },
  {
    name: '巴基斯坦',
    en_name: 'Pakistan',
    country_code: 'PK',
    area_phone_code: '92',
    currency: 'PKR',
    currency_name: '巴基斯坦卢比',
    id: 181
  },
  {
    name: '巴拿马',
    en_name: 'PANAMA',
    country_code: 'PA',
    area_phone_code: '507',
    currency: 'USD',
    currency_name: '美元',
    id: 184
  },
  {
    name: '罗马尼亚',
    en_name: 'ROMANIA',
    country_code: 'RO',
    area_phone_code: '40',
    currency: 'RON',
    currency_name: '罗马尼亚列伊',
    id: 135
  },
  {
    name: '卢旺达',
    en_name: 'RWANDA',
    country_code: 'RW',
    area_phone_code: '250',
    currency: 'RWF',
    currency_name: '卢旺达法郎',
    id: 136
  },
  {
    name: '圣露西亚',
    en_name: 'SAINT LUCIA',
    country_code: 'LC',
    area_phone_code: '1758',
    currency: 'XCD',
    currency_name: '东加勒比元',
    id: 138
  },
  {
    name: '圣马丁岛（荷兰语部分）',
    en_name: 'SINT MAARTEN (DUTCH PART)',
    country_code: 'MF',
    area_phone_code: '590',
    currency: 'ANG',
    currency_name: '荷属安的列斯盾',
    id: 149
  },
  {
    name: '圣皮埃尔和密克隆',
    en_name: 'SAINT PIERRE AND MIQUELON',
    country_code: 'PM',
    area_phone_code: '508',
    currency: 'EUR',
    currency_name: '欧元',
    id: 139
  },
  {
    name: '圣文森特和格林纳丁斯',
    en_name: 'SAINT VINCENT AND THE GRENADINES',
    country_code: 'VC',
    area_phone_code: '1784',
    currency: 'XCD',
    currency_name: '东加勒比元',
    id: 140
  },
  {
    name: '萨摩亚',
    en_name: 'SAMOA',
    country_code: 'WS',
    area_phone_code: '685',
    currency: 'WST',
    currency_name: '塔拉',
    id: 141
  },
  {
    name: '圣马利诺',
    en_name: 'SAN MARINO',
    country_code: 'SM',
    area_phone_code: '378',
    currency: 'EUR',
    currency_name: '欧元',
    id: 142
  },
  {
    name: '圣多美和普林西比',
    en_name: 'SAO TOME AND PRINCIPE',
    country_code: 'ST',
    area_phone_code: '239',
    currency: 'STN',
    currency_name: '多布拉',
    id: 143
  },
  {
    name: '沙特阿拉伯',
    en_name: 'SAUDI ARABIA',
    country_code: 'SA',
    area_phone_code: '966',
    currency: 'SAR',
    currency_name: '沙特里亚尔',
    id: 144
  },
  {
    name: '塞内加尔',
    en_name: 'SENEGAL',
    country_code: 'SN',
    area_phone_code: '221',
    currency: 'XOF',
    currency_name: '多哥非洲共同体法郎',
    id: 145
  },
  {
    name: '塞舌尔',
    en_name: 'SEYCHELLES',
    country_code: 'SC',
    area_phone_code: '248',
    currency: 'SCR',
    currency_name: '塞舌尔卢比',
    id: 146
  },
  {
    name: '塞拉利昂',
    en_name: 'SIERRA LEONE',
    country_code: 'SL',
    area_phone_code: '232',
    currency: 'SLL',
    currency_name: '利昂',
    id: 147
  },
  {
    name: '新加坡',
    en_name: 'SINGAPORE',
    country_code: 'SG',
    area_phone_code: '65',
    currency: 'SGD',
    currency_name: '新加坡元',
    id: 148
  },
  {
    name: '斯洛伐克',
    en_name: 'SLOVAKIA',
    country_code: 'SK',
    area_phone_code: '421',
    currency: 'EUR',
    currency_name: '欧元',
    id: 150
  },
  {
    name: '斯洛文尼亚',
    en_name: 'SLOVENIA',
    country_code: 'SI',
    area_phone_code: '386',
    currency: 'EUR',
    currency_name: '欧元',
    id: 151
  },
  {
    name: '所罗门群岛',
    en_name: 'SOLOMON ISLANDS',
    country_code: 'SB',
    area_phone_code: '677',
    currency: 'SBD',
    currency_name: '所罗门群岛元',
    id: 152
  },
  {
    name: '南非',
    en_name: 'SOUTH AFRICA',
    country_code: 'ZA',
    area_phone_code: '27',
    currency: 'ZAR',
    currency_name: '兰特',
    id: 153
  },
  {
    name: '西班牙',
    en_name: 'SPAIN',
    country_code: 'ES',
    area_phone_code: '34',
    currency: 'EUR',
    currency_name: '欧元',
    id: 154
  },
  {
    name: '斯里兰卡',
    en_name: 'SRILANKA',
    country_code: 'LK',
    area_phone_code: '94',
    currency: 'LKR',
    currency_name: '斯里兰卡卢比',
    id: 187
  },
  {
    name: '瑞典',
    en_name: 'SWEDEN',
    country_code: 'SE',
    area_phone_code: '46',
    currency: 'SEK',
    currency_name: '瑞典克朗',
    id: 157
  },
  {
    name: '瑞士',
    en_name: 'SWITZERLAND',
    country_code: 'CH',
    area_phone_code: '41',
    currency: 'CHW',
    currency_name: 'WIR法郎',
    id: 158
  },
  {
    name: '台湾',
    en_name: 'TAIWAN',
    country_code: 'TW',
    area_phone_code: '886',
    currency: 'TWD',
    currency_name: '新台币元',
    id: 159
  },
  {
    name: '塔吉克斯坦',
    en_name: 'TAJIKISTAN',
    country_code: 'TJ',
    area_phone_code: '992',
    currency: 'TJS',
    currency_name: '索摩尼',
    id: 160
  },
  {
    name: '泰国',
    en_name: 'THAILAND',
    country_code: 'TH',
    area_phone_code: '66',
    currency: 'THB',
    currency_name: '泰铢',
    id: 162
  },
  {
    name: '蒂莫尔-莱斯特',
    en_name: 'TIMOR-LESTE',
    country_code: 'TL',
    area_phone_code: '670',
    currency: 'USD',
    currency_name: '美元',
    id: 163
  },
  {
    name: '多哥',
    en_name: 'TOGO',
    country_code: 'TG',
    area_phone_code: '228',
    currency: 'XOF',
    currency_name: '多哥非洲共同体法郎',
    id: 164
  },
  {
    name: '汤加',
    en_name: 'TONGA',
    country_code: 'TO',
    area_phone_code: '676',
    currency: 'TOP',
    currency_name: '潘加',
    id: 165
  },
  {
    name: '土耳其',
    en_name: 'TURKEY',
    country_code: 'TR',
    area_phone_code: '90',
    currency: 'TRY',
    currency_name: '土耳其里拉',
    id: 166
  },
  {
    name: '土库曼斯坦',
    en_name: 'TURKMENISTAN',
    country_code: 'TM',
    area_phone_code: '993',
    currency: 'TMT',
    currency_name: '土库曼斯坦新马纳特',
    id: 167
  },
  {
    name: '特克斯和凯科斯群岛',
    en_name: 'TURKS AND CAICOS ISLANDS',
    country_code: 'TC',
    area_phone_code: '1649',
    currency: 'USD',
    currency_name: '美元',
    id: 168
  },
  {
    name: '图瓦卢',
    en_name: 'TUVALU',
    country_code: 'TV',
    area_phone_code: '688',
    currency: 'AUD',
    currency_name: '澳元',
    id: 169
  },
  {
    name: '乌干达',
    en_name: 'UGANDA',
    country_code: 'UG',
    area_phone_code: '256',
    currency: 'UGX',
    currency_name: '乌干达先令',
    id: 188
  },
  {
    name: '阿拉伯联合酋长国',
    en_name: 'UNITED ARAB EMIRATES',
    country_code: 'AE',
    area_phone_code: '971',
    currency: 'AED',
    currency_name: '阿联酋迪拉姆',
    id: 170
  },
  {
    name: '英国',
    en_name: 'UNITED KINGDOM',
    country_code: 'GB',
    area_phone_code: '44',
    currency: 'GBP',
    currency_name: '英镑',
    id: 171
  },
  {
    name: '美国',
    en_name: 'UNITED STATES',
    country_code: 'US',
    area_phone_code: '1',
    currency: 'USD',
    currency_name: '美元',
    id: 172
  },
  {
    name: '乌拉圭',
    en_name: 'URUGUAY',
    country_code: 'UY',
    area_phone_code: '598',
    currency: 'UYI',
    currency_name: '乌拉圭比索',
    id: 173
  },
  {
    name: '乌兹别克斯坦',
    en_name: 'UZBEKISTAN',
    country_code: 'UZ',
    area_phone_code: '998',
    currency: 'UZS',
    currency_name: '乌兹别克斯坦萨',
    id: 174
  },
  {
    name: '瓦努阿图',
    en_name: 'VANUATU',
    country_code: 'VU',
    area_phone_code: '678',
    currency: 'VUV',
    currency_name: '瓦图',
    id: 175
  },
  {
    name: '越南',
    en_name: 'VIETNAM',
    country_code: 'VN',
    area_phone_code: '84',
    currency: 'VND',
    currency_name: '越南盾',
    id: 176
  },
  {
    name: '瓦利斯和富图纳',
    en_name: 'WALLIS AND FUTUNA',
    country_code: 'WF',
    area_phone_code: '681',
    currency: 'XOF',
    currency_name: '多哥非洲共同体法郎',
    id: 179
  },
  {
    name: '赞比亚',
    en_name: 'ZAMBIA',
    country_code: 'ZM',
    area_phone_code: '260',
    currency: 'ZMW',
    currency_name: '赞比亚克瓦查',
    id: 180
  },
  {
    name: '安圭拉',
    en_name: 'ANGUILLA',
    country_code: 'AI',
    area_phone_code: '1264',
    currency: 'XCD',
    currency_name: '东加勒比元',
    id: 5
  },
  {
    name: '英属维尔京群岛',
    en_name: 'VIRGIN ISLANDS, BRITISH',
    country_code: 'VG',
    area_phone_code: '1284',
    currency: 'USD',
    currency_name: '美元',
    id: 178
  },
  {
    name: '布基纳法索',
    en_name: 'BURKINA FASO',
    country_code: 'BF',
    area_phone_code: '226',
    currency: 'XOF',
    currency_name: '多哥非洲共同体法郎',
    id: 26
  },
  {
    name: '博内尔、圣尤斯特歇斯和萨巴',
    en_name: 'BONAIRE, SINT EUSTATIUS AND SABA',
    country_code: 'BQ',
    area_phone_code: '599',
    currency: 'USD',
    currency_name: '美元',
    id: 21
  },
  {
    name: '多米尼加共和国',
    en_name: 'DOMINICAN REPUBLIC',
    country_code: 'DO',
    area_phone_code: '1',
    currency: 'DOP',
    currency_name: '多米尼加比索',
    id: 43
  },
  {
    name: '法属圭亚那',
    en_name: 'FRENCH GUIANA',
    country_code: 'GF',
    area_phone_code: '594',
    currency: 'EUR',
    currency_name: '欧元',
    id: 55
  },
  {
    name: '瓜地马拉',
    en_name: 'GUATEMALA',
    country_code: 'GT',
    area_phone_code: '502',
    currency: 'GTQ',
    currency_name: '格查尔',
    id: 67
  },
  {
    name: '爱尔兰',
    en_name: 'IRELAND',
    country_code: 'IE',
    area_phone_code: '353',
    currency: 'EUR',
    currency_name: '欧元',
    id: 76
  },
  {
    name: '拉脱维亚',
    en_name: 'LATVIA',
    country_code: 'LV',
    area_phone_code: '371',
    currency: 'EUR',
    currency_name: '欧元',
    id: 90
  },
  {
    name: '墨西哥',
    en_name: 'MEXICO',
    country_code: 'MX',
    area_phone_code: '52',
    currency: 'MXV',
    currency_name: '墨西哥基金（UDI）',
    id: 105
  },
  {
    name: '密克罗尼西亚联邦',
    en_name: 'MICRONESIA (FEDERATED STATES OF)',
    country_code: 'FM',
    area_phone_code: '691',
    currency: 'USD',
    currency_name: '美元',
    id: 106
  },
  {
    name: '纳米比亚',
    en_name: 'NAMIBIA',
    country_code: 'NA',
    area_phone_code: '264',
    currency: 'ZAR',
    currency_name: '兰特',
    id: 113
  },
  {
    name: '留尼旺岛',
    en_name: 'REUNION',
    country_code: 'RE',
    area_phone_code: '262',
    currency: 'EUR',
    currency_name: '欧元',
    id: 134
  },
  {
    name: '圣赫勒拿、阿森松岛和特里斯坦达库尼亚',
    en_name: 'ST HELENA,ASCENSION AND TRISTAN DA CUNHA',
    country_code: 'SH',
    area_phone_code: '290',
    currency: 'SHP',
    currency_name: '圣赫勒拿镑',
    id: 155
  },
  {
    name: '圣基茨和尼维斯',
    en_name: 'SAINT KITTS AND NEVIS',
    country_code: 'KN',
    area_phone_code: '1869',
    currency: 'XCD',
    currency_name: '东加勒比元',
    id: 137
  },
  {
    name: '苏里南',
    en_name: 'SURINAME',
    country_code: 'SR',
    area_phone_code: '597',
    currency: 'SRD',
    currency_name: '苏里南元',
    id: 156
  },
  {
    name: '坦桑尼亚联合共和国',
    en_name: 'TANZANIA',
    country_code: 'TZ',
    area_phone_code: '255',
    currency: 'TZS',
    currency_name: '坦桑尼亚先令',
    id: 161
  },
  {
    name: '阿尔及利亚',
    en_name: 'ALGERIA',
    country_code: 'DZ',
    area_phone_code: '213',
    currency: 'DZD',
    currency_name: '阿尔及利亚第纳尔',
    id: 2
  },
  {
    name: '维尔京群岛（美国）',
    en_name: 'VIRGIN ISLANDS (U.S.)',
    country_code: 'VI',
    area_phone_code: '1340',
    currency: 'USD',
    currency_name: '美元',
    id: 177
  },
  {
    name: '美属萨摩亚',
    en_name: 'AMERICAN SAMOA',
    country_code: 'AS',
    area_phone_code: '1684',
    currency: 'USD',
    currency_name: '美元US Dollar',
    id: 3
  }
]
